import { render } from "./Codes.vue?vue&type=template&id=959b48ee&scoped=true"
import script from "./Codes.vue?vue&type=script&lang=js"
export * from "./Codes.vue?vue&type=script&lang=js"

import "./Codes.vue?vue&type=style&index=0&id=959b48ee&scoped=true&lang=css"

import exportComponent from "/Users/alexmeister/Documents/GitHub/barq2_0_new/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-959b48ee"]])

export default __exports__